import axios from 'axios';


const baseURL="https://ethiopianpassportapi.ethiopianairlines.com";
// const baseURL="https://epassportservicesaddt-staging.azurewebsites.net";

const axiosInstance = axios.create({
    baseURL: baseURL,
    headers: {
        "Access-Control-Allow-Credentials": true
    }
});

// Proper response interceptor
axiosInstance.interceptors.response.use(
    (response) => response, // Just return the response as is
    (error) => {
        console.error("API Error:", error.response || error.message);
        return Promise.reject(error);
    }
);


export default axiosInstance;